import { VBtn } from 'vuetify/lib'

/**
 *  A map of wrapper types props, so we can handle complex props combination
 *  by passing a single prop "wrapperType" to the target
 */
const wrapperTypesMap = {
  primary: {
    color: 'primary'
  },
  delete: {
    color: 'primary'
  },
  magnify: {
    color: 'primary'
  }
}

export default {
  inheritAttrs: false,
  props: {
    wrapperType: String
  },
  components: {
    VBtn
  },
  computed: {
    classes () {
      return ''
    },

    commonAttrs () {
      const wrapperTypeProps = wrapperTypesMap[this.wrapperType] || {}
      return {
        ...wrapperTypeProps
      }
    },

    overrideAttrs () {
      return {
      }
    }
  }
}
